import {State} from '@ngxs/store';
import {AdvertiserBillingOperationsModel} from './advertiser-billing-operations.model';
import {Injectable} from '@angular/core';
import {AdvertiserBillingService} from '../../services-advertiser/billing/billing.service';
import {Observable} from 'rxjs';
import {IResponse} from '@interfaces/response';
import {finalize, tap} from 'rxjs/operators';
import {IAdvertiserBillingOperations} from '@interfaces/advertiser/billing';
import {OrderType} from '../../types/order.type';
import {AdvertiserBillingOperationsSortType} from '../../types/advertiser-billing-operations.type';
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

@StateRepository()
@State<AdvertiserBillingOperationsModel>({
  name: 'advertiserBillingOperationState',
  defaults: {
    currentPage: 1,
    total: 0,
    search: '',
    order: 'DESC',
    itemsPerPage: 10,
    loader: false,
    operations: [],
    sort: 'id',
  }
})

@Injectable()
export class AdvertiserBillingOperationsState extends NgxsDataRepository<AdvertiserBillingOperationsModel> {
  constructor(private billingService: AdvertiserBillingService) {
    super();
  }

  @DataActionWithoutSubscription({cancelUncompleted: true})
  getOperations(): Observable<IResponse<IAdvertiserBillingOperations>> {
    const limit = this.ctx.getState().itemsPerPage;
    const skip = limit * (this.ctx.getState().currentPage - 1);
    const order = this.ctx.getState().order;
    const sort = this.ctx.getState().sort;
    const search = this.ctx.getState().search;
    this.ctx.patchState({loader: true});
    return this.billingService.getBillingOperations({limit, skip, order, sort, search})
      .pipe(
        tap((operations) => {
          const state = this.ctx.getState();
          this.ctx.setState({...state, operations: operations.rows, total: operations.count});
        }),
        finalize(() => this.ctx.patchState({loader: false}))
      );
  }

  @DataActionWithoutSubscription()
  setPage(@Payload('[Advertiser billing operations] get operations by page') page: number): Observable<any> {
    this.ctx.patchState({currentPage: page});
    return this.getOperations();
  }

  @DataActionWithoutSubscription()
  search(@Payload('[Advertiser billing operations] search operations') search: string): Observable<any> {
    this.ctx.patchState({search, currentPage: 1});
    return this.getOperations();
  }

  @DataActionWithoutSubscription()
  sort(@Payload('[Advertiser billing holds] sort operations')
         payload: { sort: AdvertiserBillingOperationsSortType, order: OrderType }): Observable<any> {
    this.ctx.patchState({order: payload.order, sort: payload.sort});
    return this.getOperations();
  }
}
